import 'js-polyfills/dom';
import 'js-polyfills/html';
import 'core-js';
import 'classlist-polyfill';
import objectFitImages from 'object-fit-images';
import 'svgxuse';
import 'flickity';
import 'fslightbox'

import './components/mdc-ripple';
import './components/input';
import './components/login';
import './components/logout';
import './components/session-timer';
import './components/megaNav';
import './components/cookiespopup';
import './components/snackbar';
import './react/components/Navigation';

objectFitImages('img');
